<template>
    
    <div class="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <!-- Sidebar -->
<component 
  :is="layoutMap[currentModule].sidebar"
  :isOpen="isSidebarOpen" 
/>
      <!-- Main Content -->
      <main 
        class="flex-1 overflow-x-hidden transition-all duration-300"
        :class="{'ml-64': isSidebarOpen, 'ml-0': !isSidebarOpen}"
      >
        <!-- Navbar -->
       <header 
        class="fixed top-0 z-50 w-full bg-white dark:bg-gray-800 shadow-sm transition-all duration-300"
      >
<component 
  :is="layoutMap[currentModule].topbar"
  :page-title="currentPageTitle"
  :is-sidebar-open="isSidebarOpen"
  :is-dark-mode="isDarkMode"
  @toggle-sidebar="toggleSidebar"
  @toggle-dark-mode="toggleDarkMode"
/>
      </header>

            <div class="max-w-4xl mt-4 mb-4 mx-auto p-6 bg-white rounded-lg shadow-md mt-[100px] mb-5">

      <h1 class="text-2xl font-bold text-[#035a76] mb-6">Employee Onboarding Form</h1>
      
      <!-- Progress Indicator -->
      <div class="mb-8">
        <div class="flex justify-between mb-2">
          <span v-for="(step, index) in steps" :key="index" 
                :class="{'font-bold': currentStep === index + 1, 'text-[#035a76]': currentStep >= index + 1}"
                class="text-sm">
            {{ step }}
          </span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-2.5">
          <div class="bg-[#76ba51] h-2.5 rounded-full" 
               :style="`width: ${(currentStep / steps.length) * 100}%`"></div>
        </div>
      </div>
  
      <form novalidate @submit.prevent="submitForm">
        <!-- Step 1: Personal Information -->
        <div v-show="currentStep === 1" class="space-y-6">
          <h2 class="text-xl font-semibold border-b pb-2">Personal Information</h2>
          
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label class="block text-sm font-medium text-gray-700">First Name<span class="text-red-500">*</span></label>
              <input v-model="form.personal.firstName" type="text" 
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                       <p v-if="errors.firstName" class="text-red-500 text-sm mt-1">{{ errors.firstName }}</p>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">Middle Name</label>
              <input v-model="form.personal.middleName" type="text"
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">Last Name<span class="text-red-500">*</span></label>
              <input v-model="form.personal.lastName" type="text"
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                       <p v-if="errors.lastName" class="text-red-500 text-sm mt-1">{{ errors.lastName }}</p>
            </div>
          </div>
  
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label class="block text-sm font-medium text-gray-700">Gender<span class="text-red-500">*</span></label>
              <select v-model="form.personal.gender" required
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
              <p v-if="errors.gender" class="text-red-500 text-sm mt-1">{{ errors.gender }}</p>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">Date of Birth<span class="text-red-500">*</span></label>
              <input v-model="form.personal.dob" type="date" name="personal[dob]"
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                       <p v-if="errors.dob" class="text-red-500 text-sm mt-1">{{ errors.dob }}</p>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">Place of Birth<span class="text-red-500">*</span></label>
              <input v-model="form.personal.placeOfBirth" type="text" 
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                       <p v-if="errors.placeOfBirth" class="text-red-500 text-sm mt-1">{{ errors.placeOfBirth }}</p>
            </div>
          </div>
  
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="block text-sm font-medium text-gray-700">Nationality<span class="text-red-500">*</span></label>
              <input v-model="form.personal.nationality" type="text" 
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                       <p v-if="errors.nationality" class="text-red-500 text-sm mt-1">{{ errors.nationality }}</p>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">Phone Number<span class="text-red-500">*</span></label>
              <input v-model="form.personal.phone" type="tel" 
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                       <p v-if="errors.phone" class="text-red-500 text-sm mt-1">{{ errors.phone }}</p>
            </div>
          </div>
  
          <div>
            <label class="block text-sm font-medium text-gray-700">Email Address<span class="text-red-500">*</span></label>
            <input v-model="form.personal.email" type="email"
                   class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                       <p v-if="errors.email" class="text-red-500 text-sm mt-1">{{ errors.email }}</p>
          </div>
  
          <div>
            <label class="block text-sm font-medium text-gray-700">Residential Address<span class="text-red-500">*</span></label>
            <textarea v-model="form.personal.address" rows="3"
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]"></textarea>
                       <p v-if="errors.address" class="text-red-500 text-sm mt-1">{{ errors.address }}</p>
          </div>
        </div>
  
        <!-- Step 2: Marital Status & Family -->
        <div v-show="currentStep === 2" class="space-y-6">
  <h2 class="text-xl font-semibold border-b pb-2">Marital Status & Family Information</h2>
  
  <div>
    <label class="block text-sm font-medium text-gray-700 mb-2">Marital Status<span class="text-red-500">*</span></label>
    <div class="space-y-2">
      <div v-for="status in maritalStatuses" :key="status.value" class="flex items-center">
        <input :id="`marital-${status.value}`" v-model="form.marital.status" :value="status.value" 
               type="radio" required class="h-4 w-4 text-[#035a76] focus:ring-[#035a76] border-gray-300">
        <label :for="`marital-${status.value}`" class="ml-2 block text-sm text-gray-700">
          {{ status.label }}
        </label>
      </div>
      <div v-if="errors.status" class="text-red-500 text-sm mt-1">
        {{ errors.status }}
      </div>
    </div>
  </div>

  <div v-if="form.marital.status === 'married'" class="mt-4">
    <label class="block text-sm font-medium text-gray-700">Spouse Name<span class="text-red-500">*</span></label>
    <input v-model="form.marital.spouseName" type="text" 
           class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">

  </div>

  <div class="mt-6">
    <div class="flex items-center">
      <input id="has-children" v-model="form.marital.hasChildren" type="checkbox" 
             class="h-4 w-4 text-[#035a76] focus:ring-[#035a76] border-gray-300 rounded">
      <label for="has-children" class="ml-2 block text-sm text-gray-700">
        Do you have any children?
      </label>
    </div>

    <div v-if="form.marital.hasChildren" class="mt-4 space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700">Number of Children<span class="text-red-500">*</span></label>
        <input 
          v-model.number="form.marital.numberOfChildren" 
          type="number" 
          min="1" 
          max="20"
          @change="updateChildrenFields"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
      </div>

      <transition-group name="fade" tag="div">
        <div v-for="(child, index) in form.marital.children" :key="index" class="border p-4 rounded-md">
          <div class="flex justify-between items-center mb-3">
            <h3 class="text-sm font-medium">Child {{ index + 1 }}</h3>
            <button 
              v-if="form.marital.children.length > 1"
              type="button" 
              @click="removeChild(index)"
              class="text-red-600 hover:text-red-800 text-sm font-medium">
              Remove
            </button>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700">Full Name<span class="text-red-500">*</span></label>
              <input 
                v-model="child.fullName" 
                type="text" 
                required
                class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">Age<span class="text-red-500">*</span></label>
              <input 
                v-model.number="child.age" 
                type="number" 
                min="0" 
                max="30"
                required
                class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
          </div>
        </div>
      </transition-group>
      
      <button 
        type="button" 
        @click="addChild"
        class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-[#035a76] bg-[#76ba51]/10 hover:bg-[#76ba51]/20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#035a76]">
        <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        Add Another Child
      </button>
    </div>
  </div>

  
          <div class="mt-6">
            <h3 class="text-lg font-medium border-b pb-2">Parents Information</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              <div>
                <label class="block text-sm font-medium text-gray-700">Father's Name<span class="text-red-500">*</span></label>
                <input v-model="form.parents.fatherName" type="text"
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                       <p v-if="errors.fatherName" class="text-red-500 text-sm mt-1">{{ errors.fatherName }}</p>

              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Father's Contact<span class="text-red-500">*</span></label>
                <input v-model="form.parents.fatherContact" type="tel"
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">

              </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              <div>
                <label class="block text-sm font-medium text-gray-700">Mother's Name<span class="text-red-500">*</span></label>
                <input v-model="form.parents.motherName" type="text"
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                       <p v-if="errors.motherName" class="text-red-500 text-sm mt-1">{{ errors.motherName }}></p>
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Mother's Contact</label>
                <input v-model="form.parents.motherContact" type="tel" 
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              </div>
            </div>
            <div class="mt-4">
              <label class="block text-sm font-medium text-gray-700">Parents' Address</label>
              <textarea v-model="form.parents.address" required rows="2"
                        class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]"></textarea>
            </div>
          </div>
        </div>
  
        <!-- Step 3: Work Experience -->
        <div v-show="currentStep === 3" class="space-y-6">
          <h2 class="text-xl font-semibold border-b pb-2">Work Experience</h2>
          
          <div v-for="(exp, index) in form.workExperience" :key="index" class="border p-4 rounded-md">
            <div class="flex justify-between items-center mb-3">
              <h3 class="text-sm font-medium">Previous Work {{ index + 1 }}</h3>
              <button v-if="index > 0" type="button" @click="removeWorkExperience(index)"
                      class="text-red-600 hover:text-red-800 text-sm font-medium">
                Remove
              </button>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label class="block text-sm font-medium text-gray-700">Company Name<span class="text-red-500">*</span></label>
                <input v-model="exp.company" type="text" 
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Position Held<span class="text-red-500">*</span></label>
                <input v-model="exp.position" type="text" 
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              </div>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              <div>
                <label class="block text-sm font-medium text-gray-700">Company Address<span class="text-red-500">*</span></label>
                <input v-model="exp.address" type="text" 
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Contact Person/Number</label>
                <input v-model="exp.contact" type="text"
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              </div>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              <div>
                <label class="block text-sm font-medium text-gray-700">Start Date<span class="text-red-500">*</span></label>
                <input v-model="exp.startDate" type="date" 
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">End Date<span class="text-red-500">*</span></label>
                <input v-model="exp.endDate" type="date" 
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              </div>
            </div>
            
            <div class="mt-4">
              <label class="block text-sm font-medium text-gray-700">Reason for Leaving<span class="text-red-500">*</span></label>
              <textarea v-model="exp.reasonForLeaving" required rows="2"
                        class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]"></textarea>
            </div>
          </div>
          
          <button type="button" @click="addWorkExperience"
                  class="mt-4 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-[#035a76] bg-[#76ba51]/10 hover:bg-[#76ba51]/20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#035a76]">
            <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            Add Another Work Experience
          </button>
        </div>
  
        <!-- Step 4: Education -->
        <div v-show="currentStep === 4" class="space-y-6">
          <h2 class="text-xl font-semibold border-b pb-2">Education Background</h2>
          
          <div v-for="(edu, index) in form.education" :key="index" class="border p-4 rounded-md">
            <div class="flex justify-between items-center mb-3">
              <h3 class="text-sm font-medium">Education {{ index + 1 }}</h3>
              <button v-if="index > 0" type="button" @click="removeEducation(index)"
                      class="text-red-600 hover:text-red-800 text-sm font-medium">
                Remove
              </button>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label class="block text-sm font-medium text-gray-700">Certificate/Degree<span class="text-red-500">*</span></label>
                <select v-model="edu.certificate" required
                        class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                  <option value="">Select Certificate</option>
                  <option value="WASSCE">WASSCE</option>
                  <option value="Diploma">Diploma</option>
                  <option value="Bachelor">Bachelor's Degree</option>
                  <option value="Master">Master's Degree</option>
                  <option value="PhD">PhD</option>
                  <option value="Other">Other</option>
                </select>
                <input v-if="edu.certificate === 'Other'" v-model="edu.otherCertificate" type="text" required
                       class="mt-2 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">School Name<span class="text-red-500">*</span></label>
                <input v-model="edu.school" type="text" required
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              </div>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              <div>
                <label class="block text-sm font-medium text-gray-700">Start Year<span class="text-red-500">*</span></label>
                <input v-model="edu.startYear" type="number" min="1900" :max="new Date().getFullYear()" :name="`education[${index}][startYear]`" required
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">End Year<span class="text-red-500">*</span></label>
                <input v-model="edu.endYear" type="number" min="1900" :max="new Date().getFullYear()" :name="`education[${index}][endYear]`" required
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              </div>
            </div>
          </div>
          
          <button type="button" @click="addEducation"
                  class="mt-4 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-[#035a76] bg-[#035a76]/10 hover:bg-[#035a76]/20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#035a76]">
            <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            Add Another Education
          </button>
        </div>
  
        <!-- Step 5: Emergency Contact & Documents -->
        <div v-show="currentStep === 5" class="space-y-6">
          <h2 class="text-xl font-semibold border-b pb-2">Emergency Contact</h2>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="block text-sm font-medium text-gray-700">Full Name<span class="text-red-500">*</span></label>
              <input v-model="form.emergencyContact.fullName" type="text" required
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">Relationship<span class="text-red-500">*</span></label>
              <input v-model="form.emergencyContact.relationship" type="text" required
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
          </div>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="block text-sm font-medium text-gray-700">Phone Number<span class="text-red-500">*</span></label>
              <input v-model="form.emergencyContact.phone" type="tel" required
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">Alternative Phone</label>
              <input v-model="form.emergencyContact.altPhone" type="tel"
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700">Address<span class="text-red-500">*</span></label>
            <textarea v-model="form.emergencyContact.address" required rows="2"
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]"></textarea>
          </div>
  
          <h2 class="text-xl font-semibold border-b pb-2 mt-8">Bank Details</h2>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="block text-sm font-medium text-gray-700">Bank Name<span class="text-red-500">*</span></label>
              <input v-model="form.bank.bankName" type="text" required
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
             <div>
              <label class="block text-sm font-medium text-gray-700">Branch Name<span class="text-red-500">*</span></label>
              <input v-model="form.bank.branchName" type="text" required
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>           
            <div>
              <label class="block text-sm font-medium text-gray-700">Account Number<span class="text-red-500">*</span></label>
              <input v-model="form.bank.accountNumber" type="text" required
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700">Account Holder Name<span class="text-red-500">*</span></label>
            <input v-model="form.bank.accountName" type="text" required
                   class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
          </div>
  
          <h2 class="text-xl font-semibold border-b pb-2 mt-8">Security Information</h2>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="block text-sm font-medium text-gray-700">Ghana Card Number<span class="text-red-500">*</span></label>
              <input v-model="form.security.ghanaCardNumber" type="text" required
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">Ghana Card Expiry Date<span class="text-red-500">*</span></label>
              <input v-model="form.security.ghanaCardExpiry" type="date" required
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700">SSNIT Number<span class="text-red-500">*</span></label>
            <input v-model="form.security.ssnitNumber" type="text" required
                   class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
          </div>
  
          <h2 class="text-xl font-semibold border-b pb-2 mt-8">Document Uploads</h2>
          
          <div class="space-y-4">
            <div>
              <label class="block text-sm font-medium text-gray-700">Curriculum Vitae (CV)<span class="text-red-500">*</span></label>
              <input type="file" @change="handleFileUpload('cv', $event)" accept=".pdf,.doc,.docx" required
                     class="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#035a76]/10 file:text-[#035a76] hover:file:bg-[#035a76]/20">
              <p class="mt-1 text-xs text-gray-500">PDF or Word document (Max 5MB)</p>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-medium text-gray-700">Ghana Card (Front)<span class="text-red-500">*</span></label>
                <input type="file" @change="handleFileUpload('ghanaCardFront', $event)" accept="image/*,.pdf" required
                       class="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#035a76]/10 file:text-[#035a76] hover:file:bg-[#035a76]/20">
                <p class="mt-1 text-xs text-gray-500">Image or PDF (Max 5MB)</p>
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Ghana Card (Back)<span class="text-red-500">*</span></label>
                <input type="file" @change="handleFileUpload('ghanaCardBack', $event)" accept="image/*,.pdf" required
                       class="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#035a76]/10 file:text-[#035a76] hover:file:bg-[#035a76]/20">
                <p class="mt-1 text-xs text-gray-500">Image or PDF (Max 5MB)</p>
              </div>
            </div>
            
            <div>
              <label class="block text-sm font-medium text-gray-700">NHIS Card<span class="text-red-500">*</span></label>
              <input type="file" @change="handleFileUpload('nhisCard', $event)" accept="image/*,.pdf" required
                     class="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#035a76]/10 file:text-[#035a76] hover:file:bg-[#035a76]/20">
              <p class="mt-1 text-xs text-gray-500">Image or PDF (Max 5MB)</p>
            </div>
          </div>
        </div>

        <div v-show="currentStep === 6" class="space-y-6">
          <h2 class="text-xl font-semibold border-b pb-2">Employee Signature</h2>

            <div class="border rounded-lg p-4 bg-gray-50">
    <canvas
      ref="signatureCanvas"
      class="w-full h-48 border rounded bg-white"
    ></canvas>
  </div>

  <div class="flex gap-3">
    <button
      type="button"
      @click="clearSignature"
      class="px-4 py-2 bg-gray-500 text-white rounded"
    >
      Clear
    </button>

    <!-- <button
      type="button"
      @click="saveSignature"
      class="px-4 py-2 bg-blue-600 text-white rounded"
    >
      Save Signature
    </button> -->
  </div>

        </div>
  
        <!-- Navigation Buttons -->
        <div class="flex justify-between mt-8">
          <button v-if="currentStep > 1" type="button" @click="prevStep"
                  class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#035a76]">
            Previous
          </button>
          <div v-else></div> <!-- Empty div for spacing -->
          
          <button v-if="currentStep < steps.length" type="button" @click="nextStep"
                  class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#76ba51] hover:bg-[#76ba51]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#035a76]">
            Next
          </button>
          
          <button v-else type="submit"
                  :disabled="isSubmitting"
                  class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#76ba51] hover:bg-[#76ba51]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
{{ isSubmitting ? 'Submitting...' : 'Submit Onboarding' }}
          </button>
        </div>
      </form>
      </div>
      </main>
<Teleport to="body">
  <div v-if="showSuccessModal" 
       class="fixed inset-0 bg-black/50 flex items-center justify-center z-[1000]"
       @click.self="showSuccessModal = false">
    <div class="bg-white p-6 rounded-lg text-center max-w-sm shadow-xl">
      <h3 class="text-xl font-semibold text-[#035a76] mb-2">✅ Submitted Successfully</h3>
      <p class="text-gray-600 mb-4">Your form has been submitted.</p>
      <button @click="showSuccessModal = false"
              class="px-5 py-2 bg-[#76ba51] text-white rounded-md hover:bg-[#76ba51]/90">
        Close
      </button>
    </div>
  </div>
</Teleport>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, nextTick,computed } from 'vue';
  import api from '@/services/api';
import HrSidebar from '@/components/hr/HrSidebar.vue'
import AcdSidebar from '@/components/acd/AcdSidebar.vue'
import CommSidebar from '@/components/com/ComSidebar.vue'
// import ProcSidebar from '@/components/ProcSidebar.vue'

import HrTopbar from '@/components/hr/HrTopbar.vue'
import AcdTopbar from '@/components/acd/AcdTopbar.vue'
import CommTopbar from '@/components/com/ComTopbar.vue'
// import ProcTopbar from '@/components/ProcTopbar.vue'
import ItSidebar from '@/components/it/ItSidebar.vue';
import ItTopbar from '@/components/it/ItTopbar.vue';


  import SignaturePad from "signature_pad";
  import { useRoute } from 'vue-router'


  const route = useRoute()

  const layoutMap = {
  hr: {
    sidebar: HrSidebar,
    topbar: HrTopbar
  },
  academics: {
    sidebar: AcdSidebar,
    topbar: AcdTopbar
  },
  // it:{
  //   sidebar: ItSidebar,
  //   topbar: ItTopbar
  // },
  it: {
    sidebar: ItSidebar,
    topbar: ItTopbar
  },
    com: {
    sidebar: CommSidebar,
    topbar: CommTopbar
  },
  // procurement: {
  //   sidebar: ProcSidebar,
  //   topbar: ProcTopbar
  // }
}

const currentModule = computed(() => {
  if (route.path.startsWith('/academics')) return 'academics'
  if(route.path.startsWith('/it')) return 'it'
  if (route.path.startsWith('/com')) return 'com'
  if (route.path.startsWith('/procurement')) return 'procurement'
  return 'hr'
})

const signatureCanvas = ref(null);
let signaturePad = null;

const signatureData = ref(null);



    const currentPageTitle = ref('Onboarding');

  
  const isSidebarOpen = ref(true);
  const isDarkMode = ref(false);
  const toggleSidebar = () => {
    isSidebarOpen.value = !isSidebarOpen.value;
  };
  
  const toggleDarkMode = () => {
    isDarkMode.value = !isDarkMode.value;
    if (isDarkMode.value) {
      document.documentElement.classList.add('dark');
      localStorage.theme = 'dark';
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.theme = 'light';
    }
  };
  
  const steps = [
    'Personal Info',
    'Family Info',
    'Work Experience',
    'Education',
    'Contacts & Docs',
    'Signature'
  ];
  
  const currentStep = ref(1);
  
  const maritalStatuses = [
    { value: 'single', label: 'Single' },
    { value: 'married', label: 'Married' },
    { value: 'divorced', label: 'Divorced' },
    { value: 'widowed', label: 'Widowed' }
  ];
  
  const form = ref({
    personal: {
      firstName: '',
      middleName: '',
      lastName: '',
      gender: '',
      dob: '',
      placeOfBirth: '',
      nationality: '',
      address: '',
      phone: '',
      email: ''
    },
    marital: {
      status: '',
      spouseName: '',
      hasChildren: false,
      numberOfChildren: 1,
      children: [{ fullName: '', age: '' }]
    },
    parents: {
      fatherName: '',
      fatherContact: '',
      motherName: '',
      motherContact: '',
      address: ''
    },
    workExperience: [
      {
        company: '',
        position: '',
        address: '',
        contact: '',
        startDate: '',
        endDate: '',
        reasonForLeaving: ''
      }
    ],
    education: [
      {
        certificate: '',
        otherCertificate: '',
        school: '',
        startYear: '',
        endYear: ''
      }
    ],
    emergencyContact: {
      fullName: '',
      relationship: '',
      phone: '',
      altPhone: '',
      address: ''
    },
    bank: {
      bankName: '',
      branchName: '',
      accountNumber: '',
      accountName: ''
    },
    security: {
      ghanaCardNumber: '',
      ghanaCardExpiry: '',
      ssnitNumber: ''
    },
    documents: {
      cv: null,
      ghanaCardFront: null,
      ghanaCardBack: null,
      nhisCard: null
    }
  });
  
  // const nextStep = () => {
  //   if (currentStep.value < steps.length) {
  //     currentStep.value++;
  //   }
  // };
  const nextStep = () => {
  if (!validateCurrentStep()) return;
  if (currentStep.value < steps.length) currentStep.value++;
};

const errors = ref({
  firstName: '',
  lastName: '',
  gender: '',
  dob: '',
  placeOfBirth: '',
  nationality: '',
  address: '',
  phone: '',
  email: ''
  
});

const validateCurrentStep = () => {
  let valid = true;

  if (currentStep.value === 1) {
    if (!form.value.personal.firstName?.trim()) {
  errors.value.firstName = 'First name is required';
      valid = false;
    }

    if (!form.value.personal.lastName?.trim()) {
      errors.value.lastName = 'Last name is required';
      valid = false;
    }
    if (!form.value.personal.dob) {
      errors.value.dob = 'Date of birth is required';
      valid = false;
    }
    if(!form.value.personal.gender?.trim()) {
      errors.value.gender = 'Gender is required';
      valid = false;
    }
    if(!form.value.personal.placeOfBirth?.trim()) {
      errors.value.placeOfBirth = 'Place of birth is required';
      valid = false;
    }
    if(!form.value.personal.nationality?.trim()) {
      errors.value.nationality = 'Nationality is required';
      valid = false;
    }
    if(!form.value.personal.address?.trim()) {
      errors.value.address = 'Address is required';
      valid = false;
    }
    if(!form.value.personal.phone?.trim()) {
      errors.value.phone = 'Phone number is required';
      valid = false;
    }
    if(!form.value.personal.email?.trim()) {
      errors.value.email = 'Email is required';
      valid = false;
    }
  }

  if (currentStep.value === 4) {
    for (const [i, edu] of form.value.education.entries()) {
      if (!edu.startYear || !edu.endYear) {
        alert(`Education entry ${i+1}: start and end year are required`);
        valid = false;
      }
    }
  }

  return valid;
};
  
  const prevStep = () => {
    if (currentStep.value > 1) {
      currentStep.value--;
    }
  };
  
  const updateChildrenFields = () => {
  const currentCount = form.value.marital.children.length;
  const newCount = form.value.marital.numberOfChildren;
  
  if (newCount > currentCount) {
    // Add new children
    for (let i = currentCount; i < newCount; i++) {
      form.value.marital.children.push({ fullName: '', age: '' });
    }
  } else if (newCount < currentCount) {
    // Remove extra children
    form.value.marital.children.splice(newCount, currentCount - newCount);
  }
};

const addChild = () => {
  form.value.marital.children.push({ fullName: '', age: '' });
  form.value.marital.numberOfChildren = form.value.marital.children.length;
};

const removeChild = (index) => {
  form.value.marital.children.splice(index, 1);
  form.value.marital.numberOfChildren = form.value.marital.children.length;
};

  const addWorkExperience = () => {
    form.value.workExperience.push({
      company: '',
      position: '',
      address: '',
      contact: '',
      startDate: '',
      endDate: '',
      reasonForLeaving: ''
    });
  };
  
  const removeWorkExperience = (index) => {
    form.value.workExperience.splice(index, 1);
  };
  
  const addEducation = () => {
    form.value.education.push({
      certificate: '',
      otherCertificate: '',
      school: '',
      startYear: '',
      endYear: ''
    });
  };
  
  const removeEducation = (index) => {
    form.value.education.splice(index, 1);
  };
  
  const handleFileUpload = (field, event) => {
    form.value.documents[field] = event.target.files[0];
  };

  const createFormData = (formObj) => {
  const formData = new FormData();

  // Personal info
  Object.keys(formObj.personal).forEach(key => {
    formData.append(`personal[${key}]`, formObj.personal[key]);
  });

  // Marital info
  Object.keys(formObj.marital).forEach(key => {
    if (key === 'children') {
      formObj.marital.children.forEach((child, i) => {
        Object.keys(child).forEach(cKey => {
          formData.append(`marital[children][${i}][${cKey}]`, child[cKey]);
        });
      });
    } else {
      formData.append(`marital[${key}]`, formObj.marital[key]);
    }
  });

  // Parents
  Object.keys(formObj.parents).forEach(key => {
    formData.append(`parents[${key}]`, formObj.parents[key]);
  });

  // Work Experience (array)
  formObj.workExperience.forEach((exp, i) => {
    Object.keys(exp).forEach(key => {
      formData.append(`workExperience[${i}][${key}]`, exp[key]);
    });
  });

  // Education (array)
  formObj.education.forEach((edu, i) => {
    Object.keys(edu).forEach(key => {
      formData.append(`education[${i}][${key}]`, edu[key]);
    });
  });

  // Emergency contact
  Object.keys(formObj.emergencyContact).forEach(key => {
    formData.append(`emergencyContact[${key}]`, formObj.emergencyContact[key]);
  });

  // Bank info
  Object.keys(formObj.bank).forEach(key => {
    formData.append(`bank[${key}]`, formObj.bank[key]);
  });

  // Security info
  Object.keys(formObj.security).forEach(key => {
    formData.append(`security[${key}]`, formObj.security[key]);
  });

  // Documents (files)
  Object.keys(formObj.documents).forEach(key => {
    if (formObj.documents[key]) {
      formData.append(`documents[${key}]`, formObj.documents[key]);
    }
  });

  return formData;
};



  
const isSubmitting = ref(false);


const clearSignature = () => {
  if (signaturePad) {
    signaturePad.clear();
  }
};

onMounted(() => {
  nextTick(() => {
    if (signatureCanvas.value) {
      signaturePad = new SignaturePad(signatureCanvas.value);
    }
  });
});
const dataURLtoBlob = (dataURL) => {
  const arr = dataURL.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], { type: mime });
};
const showSuccessModal = ref(false);

const submitForm = async () => {
  if (isSubmitting.value) {
    console.log("Already submitting – ignoring duplicate click");
    return;
  }

  if (!signaturePad || signaturePad.isEmpty()) {
    alert("Please sign before submitting");
    return;
  }

  isSubmitting.value = true;

  try {
    const formData = createFormData(form.value);
    const signatureDataURL = signaturePad.toDataURL();
    const signatureBlob = dataURLtoBlob(signatureDataURL);

    formData.append("signature", signatureBlob, "signature.png");

const response = await api.post("Staff.php", formData, {
  headers: { "Content-Type": "multipart/form-data" }
});

// Check the actual payload, not just that the request didn't throw
if (response.data?.success === false || response.data?.status === "error") {
  console.error("Server reported failure:", response.data);
  alert(response.data.message || "Submission failed. Please check your details and try again.");
  return; // stop here — don't reset form or show success modal
}

console.log("Success:", response.data);
resetForm();
showSuccessModal.value = true;

} catch (error) {
  console.error("Submit failed:", error);

  if (error.response) {
    // Server responded with a non-2xx status
    const serverMsg = error.response.data?.message;
    alert(serverMsg || `Server error (${error.response.status}). Please try again.`);
  } else if (error.request) {
    // Request made but no response received (network/timeout)
    alert("No response from server. Check your connection and try again.");
  } else {
    alert("Failed to submit. Check console or try again.");
  }
} finally {
  isSubmitting.value = false;
}
};

const resetForm = () => {
  form.value = {
    personal: {
      firstName: '',
      middleName: '',
      lastName: '',
      gender: '',
      dob: '',
      placeOfBirth: '',
      nationality: '',
      address: '',
      phone: '',
      email: ''
    },
    marital: {
      status: '',
      spouseName: '',
      hasChildren: false,
      numberOfChildren: 1,
      children: [{ fullName: '', age: '' }]
    },
    parents: {
      fatherName: '',
      fatherContact: '',
      motherName: '',
      motherContact: '',
      address: ''
    },
    workExperience: [
      {
        company: '',
        position: '',
        address: '',
        contact: '',
        startDate: '',
        endDate: '',
        reasonForLeaving: ''
      }
    ],
    education: [
      {
        certificate: '',
        otherCertificate: '',
        school: '',
        startYear: '',
        endYear: ''
      }
    ],
    emergencyContact: {
      fullName: '',
      relationship: '',
      phone: '',
      altPhone: '',
      address: ''
    },
    bank: {
      bankName: '',
      branchName: '',
      accountNumber: '',
      accountName: ''
    },
    security: {
      ghanaCardNumber: '',
      ghanaCardExpiry: '',
      ssnitNumber: ''
    },
    documents: {
      cv: null,
      ghanaCardFront: null,
      ghanaCardBack: null,
      nhisCard: null
    }
  };

  currentStep.value = 1; 
};
  </script>
  
<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-box {
  background: white;
  padding: 24px 32px;
  border-radius: 8px;
  text-align: center;
  max-width: 400px;
}
.modal-box h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: #035a76;
}
.modal-box button {
  margin-top: 16px;
  padding: 8px 20px;
  background: #76ba51;
  color: white;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}
.modal-box button:hover {
  background: #76ba51e6;
}
</style>